<mat-toolbar>
    <h4>CONFIRM</h4>
  </mat-toolbar>
<div  class="confirmMessage">{{confirmMessage}}</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="dialogRef.close(false)" color="warn">CANCEL</button>
    <button mat-raised-button class="mat-accent" color="accent" (click)="dialogRef.close(true)">CONFIRM</button>
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/confirm-dialog/confirm-dialog.component.html